class DelegationState {
  private _actingAsProviderId: number | undefined;

  setActingAsProvider(id: number | undefined) {
    this._actingAsProviderId = id;
  }

  getActingAsProviderId() {
    return this._actingAsProviderId;
  }
}

export default new DelegationState();
